import { Grid, Typography } from "@mui/material";

import styles from './index.module.css'
import PricingTable from "../../PricingTable";


const TotalContainer = ({ otherServices, invoiceDetails }) => {
  const currencyCode = (
    invoiceDetails?.currency ||
    invoiceDetails?.Currency ||
    invoiceDetails?.currencyCode ||
    invoiceDetails?.CurrencyCode ||
    ''
  )?.toString().toUpperCase();
 
  return (
    <>
      <Grid container className={styles.headerContainer}>
        <Typography variant="h6">Services</Typography>
        <PricingTable
          priceDetails={otherServices}
          {...(currencyCode ? { currency: currencyCode } : {})}
          isService={true}
          serviceTaxBreakdown={true}
        />
      </Grid>
    </>

  )
}

export default TotalContainer
